module.exports = __webpack_public_path__ + "static/img/garage-door-extension-springs.7aec83a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/misc/garage-door-extension-springs.jpg
// module id = xBM2
// module chunks = 1